<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-06-21 11:40:02
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\CompanyManagement\Tax\components\uploadFile.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-14 14:01:19
-->
<template>
  <normalDialog
    :title="$t('label_essweb_List_dialog_uploadTitleLabel')"
    :dialog="show"
    maxWidth="600"
    width="600"
    @close="$emit('close')"
  >
    <template v-slot:content>
      <v-file-input
        id="fileInput"
        hide-input
        v-show="false"
        multiple
        accept="doc,docx,pdf,ppt,jpg,jpeg,png,xlsx,xls"
        @change="chooseUploadFile"
      ></v-file-input>

      <v-form ref="form" lazy-validation>
        <v-row align="center">
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-card
              class="rounded-lg"
              :style="{ border: '2px dashed var(--main-border-color)' }"
              elevation="0"
              @dragover="fileDragover"
              @drop="fileDrop"
            >
              <v-sheet class="text-center align-center">
                <div>
                  <i
                    class="material-icons-round md-72 text--secondary lighten-2"
                    >backup</i
                  >
                </div>
                <div class="py-3">
                  <span>{{
                    $t("label_essweb_update_components_tipLabel")
                  }}</span>
                  <v-btn
                    color="primary lighten-2 "
                    small
                    rounded
                    class="text-capitalize ml-2"
                    @click="toChoose"
                    >{{
                      $t("label_essweb_update_components_browseBtnLabel")
                    }}</v-btn
                  >
                </div>
                <!-- <div class="pt-2 text--secondary">
                  <span>{{
                    $t("message_essweb_Tax_dialog_canBeExportInTipLabel")
                  }}</span>
                </div> -->
              </v-sheet>
            </v-card>
          </v-col>
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="12"
            cols="12"
            v-if="fileList.length"
          >
            <v-container
              class="scroll_content_y pa-0 ma-0"
              :style="{ maxHeight: '214px' }"
            >
              <v-sheet
                style="position: relative"
                class="rounded-lg my-2 mrc-border-solid"
                v-for="(item, index) in fileList"
                :key="`file--${index}---${item.id}`"
              >
                <v-progress-linear
                  v-if="item.uploading"
                  absolute
                  :style="{ top: 0, zIndex: 0 }"
                  height="100%"
                  background-opacity="0"
                  v-model="item.progress"
                  class="rounded-lg"
                  :buffer-value="100"
                  color="primary lighten-3"
                ></v-progress-linear>
                <v-sheet
                  class="text-left align-center d-flex transparent px-2 py-2"
                  :style="{ zIndex: 1, position: 'relative' }"
                >
                  <svg-icon
                    size="32"
                    :fill="item.updated ? '#0f46c1' : 'grey'"
                    :iconClass="
                      item.file_type == 'jpg'
                        ? 'filetype-jpg'
                        : item.file_type == 'csv'
                        ? 'filetype-csv'
                        : item.file_type == 'doc'
                        ? 'filetype-doc'
                        : item.file_type == 'gif'
                        ? 'filetype-gif'
                        : item.file_type == 'png'
                        ? 'filetype-png'
                        : item.file_type == 'xls'
                        ? 'filetype-xls'
                        : item.file_type == 'docx'
                        ? 'filetype-doc'
                        : item.file_type == 'xlsx'
                        ? 'filetype-xls'
                        : item.file_type == 'pdf'
                        ? 'filetype-pdf'
                        : item.file_type == 'ppt'
                        ? 'filetype-ppt'
                        : item.file_type == 'jpeg'
                        ? 'filetype-jpg'
                        : 'filetype-file'
                    "
                  />
                  <v-sheet
                    class="
                      text-subtitle-2
                      px-1
                      transparent
                      text-left
                      align-center
                      d-flex
                    "
                  >
                    <v-sheet
                      :style="{ maxWidth: '90%' }"
                      :title="item.filename"
                      class="text-subtitle-2 transparent text-truncate"
                      :class="item.updated_fail ? 'red--text' : 'text--primary'"
                    >
                      {{ item.filename }}
                    </v-sheet>

                    <span class="text--secondary text-caption px-1"
                      >({{ $byteconvert(item.size) }})</span
                    >
                  </v-sheet>
                  <v-spacer></v-spacer>
                  <v-btn small icon @click="deleteItem(item.id, item)">
                    <span class="material-icons-round">delete</span>
                  </v-btn>
                </v-sheet>
              </v-sheet>
            </v-container>
            <!-- <v-sheet class="text-subtitle-2"
              >{{
                $t("label_essweb_list_components_pagenations_totalLabel")
              }}:{{ fileList.length }}</v-sheet
            > -->
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_List_dialog_staffFolderLabel")
            }}</v-sheet>
            <v-autocomplete
              v-model="selectStaff"
              :items="allStaff"
              filled
              dense
              :disabled="staff ? true : false"
              append-icon="arrow_drop_down"
              single-line
              :placeholder="
                $t('label_essweb_leaveBalance_list_staffNameLabel') +
                '/' +
                $t('label_essweb_leaveBalance_list_staffIdLabel')
              "
              chips
              :open-on-clear="false"
              :filter="$staffFilter"
              :rules="$GetRules(['_Require_Rules'], [null])"
              item-text="staff_code"
              item-value="staff_id"
            >
              <template v-slot:no-data>
                <noContent />
              </template>
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :close="staff ? false : true"
                  pill
                  v-if="data.index < 1"
                  class="mx-0 mr-1 pr-2"
                  @click:close="selectStaff = ''"
                >
                  <StaffAvatar
                    left
                    :src="data.item.staff_avatar"
                    :staff_name="data.item.preferred_name"
                  />

                  <div
                    class="d-inline-block text-truncate"
                    style="max-width: 60px"
                  >
                    {{ $getCommonLangValue(data.item.preferred_name) }}
                  </div>
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list rounded width="100%" nav>
                  <v-list-item rouned width="100%" nav two-line dense>
                    <v-list-item-avatar class="ma-0 mr-1 white--text" size="36">
                      <StaffAvatar
                        size="36"
                        :src="data.item.staff_avatar"
                        :staff_name="data.item.preferred_name"
                      />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="text-body-2"
                        >{{ $getCommonLangValue(data.item.preferred_name) }}
                        <span class="text--secondary text-caption-xs">{{
                          data.item.staff_code
                        }}</span></v-list-item-title
                      >
                      <v-list-item-subtitle>{{
                        $getCommonLangValue(data.item.job_post_name)
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <DateTimePicker
              type="date"
              :label="$t('label_essweb_List_dialog_DateLabel')"
              :defaultTime="date"
              placeholder="YYYY/MM/DD"
              :rules="$GetRules(['_Require_Rules'], [null])"
              @change="
                (time) => {
                  date = time;
                }
              "
            />
          </v-col>
        </v-row> </v-form
    ></template>
    <template v-slot:actions>
      <CardActions submitBtn @submit="toSubmit" @cancel="$emit('close')" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import axios from "axios";
export default {
  name: "uploadFile_Tax",
  props: {
    show: { default: false, type: Boolean },
    staff: { default: null, type: [String, Number] },
    files: { default: [], type: [Object, Array, File, FileList] },
  },
  computed: {
    ...mapGetters(["AppInfo", "companyLang", "defaultLang"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    fileUuids() {
      let arr = [];
      this.fileList.map((item) => {
        if (item.updated && item.uuid) {
          arr.push(item.uuid);
        }
      });
      return arr;
    },
  },
  data() {
    return {
      fileList: [],
      allStaff: [],
      selectStaff: "",
      date: "",
      uploading: false,
    };
  },
  mounted() {
    this.$getStaffList().then((res) => {
      this.allStaff = res;
    });
  },
  watch: {
    fileList(val) {
      const that = this;
      val.some((item) => {
        if (!item.updated && !item.updated_fail) {
          that.toUpdate(item.file, item.id);
          return true;
        }
      });
    },
    uploading(val) {
      if (!val) {
        const that = this;
        that.fileList.some((item) => {
          if (!item.updated && !item.updated_fail) {
            that.toUpdate(item.file, item.id);
            return true;
          }
        });
      }
    },
    staff(val) {
      this.selectStaff = val;
    },
    show(val) {
      if (val) {
        this.selectStaff = this.staff;
        if (this.files) {
          this.chooseUploadFile(this.files);
        }
      } else {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.selectStaff = null;
        this.date = "";
        this.fileList = [];
      }
    },
  },
  methods: {
    toSubmit() {
      if (this.fileUuids.length == 0) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_Tax_form_noFilesLabel"),
          type: "warning",
        });
        return false;
      }
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("submit", {
        date: this.date,
        staff: this.selectStaff,
        fileUuids: this.fileUuids,
      });
    },
    chooseUploadFile: function (file) {
      const that = this;
      if (!file) return;
      new Promise((resolve, reject) => {
        file.some((item) => {
          if (!/\.(docx|pdf|jpg|jpeg|ppt|png|xls|xlsx|doc)$/.test(item.name)) {
            that.$showMessage({
              type: "error",
              color: "error",
              text:
                that.$t("message_essweb_update_components_onlyUpdateLabel") +
                "doc,docx,pdf,ppt,jpg,jpeg,png,xlsx,xls." +
                "<br/>" +
                item.name,
            });

            resolve(false);
            return true;
          }
          if (item.size > 5 * 1000 * 1000) {
            that.$showMessage({
              type: "error",
              color: "error",
              text:
                that.$t("message_essweb_update_components_sizeLessThanLabel") +
                "5MB.",
            });
            resolve(false);
            return true;
          }
        });
        resolve(true);
      }).then((res) => {
        if (res) {
          file.map((item, index) => {
            that.fileList.push({
              id: dayjs().valueOf() + " " + index,
              filename: item.name,
              uuid: null,
              size: item.size,
              file: item,
              online_file: null,
              progress: 0,
              file_type: item.name.substring(
                item.name.lastIndexOf(".") + 1,
                item.name.length
              ),
              Url: "",
              updated_fail: false,
              uploading: false,
              updated: false,
            });
          });
        }
      });

      // if (file.length == 1) {
      //   //单个文件上传
      //   this.fileList.push({
      //     id: dayjs().valueOf(),
      //     filename: file.name,
      //     uuid: null,
      //     size: file.size,
      //     file: file,
      //     online_file: null,
      //     progress: 0,
      //     file_type: file.name.substring(
      //       file.name.lastIndexOf(".") + 1,
      //       file.name.length
      //     ),
      //     Url: "",
      //     uploading: false,
      //     updated: false,
      //   });
      // }
    },
    fileDragover: function (e) {
      e.preventDefault();
    },

    deleteItem: function (id, item) {
      const that = this;
      that.bindAvatar("", item.uuid).then((res) => {
        that.fileList = that.fileList.filter((ele) => ele.id !== id);
      });
    },
    fileDrop: function (e) {
      e.preventDefault();
      const that = this;
      // if (e.dataTransfer.files.length > 1) {
      //   this.$showMessage({
      //     type: "error",
      //     color: "error",
      //     text: this.$t("message_essweb_update_components_onlyUpdateOneLabel"),
      //   });
      //   return false;
      // }
      var file = [];
      for (let index = 0; index < e.dataTransfer.files.length; index++) {
        file.push(e.dataTransfer.files[index]);
      }
      if (!file) return;
      new Promise((resolve, reject) => {
        file.some((item) => {
          if (!/\.(docx|pdf|jpg|jpeg|ppt|png|xls|xlsx|doc)$/.test(item.name)) {
            that.$showMessage({
              type: "error",
              color: "error",
              text:
                that.$t("message_essweb_update_components_onlyUpdateLabel") +
                "doc,docx,pdf,ppt,jpg,jpeg,png,xlsx,xls." +
                "<br/>" +
                item.name,
            });

            resolve(false);
            return true;
          }
          if (item.size > 5 * 1000 * 1000) {
            that.$showMessage({
              type: "error",
              color: "error",
              text:
                that.$t("message_essweb_update_components_sizeLessThanLabel") +
                "5MB.",
            });
            resolve(false);
            return true;
          }
        });
        resolve(true);
      }).then((res) => {
        if (res) {
          file.map((item, index) => {
            that.fileList.push({
              id: dayjs().valueOf() + " " + index,
              filename: item.name,
              uuid: null,
              size: item.size,
              file: item,
              online_file: null,
              progress: 0,
              file_type: item.name.substring(
                item.name.lastIndexOf(".") + 1,
                item.name.length
              ),
              Url: "",
              updated_fail: false,
              uploading: false,
              updated: false,
            });
          });
        }
      });
    },
    toChoose: function () {
      $("#fileInput").click();
    },
    setFileArgs(id, obj) {
      const that = this;
      return new Promise((resolve, reject) => {
        that.fileList.map((item, index) => {
          if (item.id === id) {
            for (let key in obj) {
              if (item[key] !== undefined) item[key] = obj[key];
            }
          }
          if (index == that.fileList.length - 1) resolve(true);
        });
      });
    },
    getUploadInfo: function (name, size, curId) {
      const that = this;
      that.setFileArgs(curId, { uploading: true, progress: 15 });
      that.uploading = true;
      return new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/fileManager/add-file-record-plan/",
            data: {
              module_uuid: "taxform",
              attachment_data_field: that.curAppInfo["user"]["thumbnail_img"],
              org_level_uuid: that.curAppInfo["user"]["org_level_uuid"],
              attachment_title: name,
              attachment_size: size,
            },
            type: "upload",
            global: false,
          })
          .then((res) => {
            that.setFileArgs(curId, { uploading: false, progress: 23 });
            reslove(res);
          })
          .catch((err) => {
            that
              .setFileArgs(curId, {
                uploading: false,
                progress: 0,
                updated_fail: true,
              })
              .then((result) => {
                that.uploading = false;
              });
            reject(err);
          });
      });
    },
    //删除图片
    async bindAvatar(uuid, del = "") {
      const that = this;
      return await new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/staff-manager/upload_staff_avatar/",
            data: {
              user_id: that.curAppInfo["user"]["user_id"],
              uuid: that.curAppInfo["user"]["uuid"],
              thumbnail_img: uuid,
              del: del,
            },
            type: "upload",
            global: false,
          })
          .then((res) => {
            reslove(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async onUploadAvatar(uuid, curId) {
      const that = this;
      that.setFileArgs(curId, { uploading: true, progress: 84 });
      return await new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/fileManager/get-file-info/",
            data: { uuid: uuid },
            type: "upload",
            global: false,
          })
          .then((res) => {
            that.setFileArgs(curId, { uploading: false, progress: 99 });
            reslove(res);
          })
          .catch((err) => {
            that
              .setFileArgs(curId, {
                uploading: false,
                progress: 0,
                updated_fail: true,
              })
              .then((result) => {
                that.uploading = false;
              });
            reject(err);
          });
      });
    },
    async UploadAvatar(file, arg, curId) {
      const that = this;
      that.setFileArgs(curId, { uploading: true, progress: 25 });
      return await new Promise((reslove, reject) => {
        that.$azureUpload(
          {
            baseUrl: arg.upload_url.split("?")[0],
            sasToken: arg.sostoken,
            file: file,
            progress: (progress) => {},
            complete: (res) => {
              that.setFileArgs(curId, { uploading: false, progress: 45 });
              reslove(true);
            },
            error: (err) => {
              that
                .setFileArgs(curId, {
                  uploading: false,
                  progress: 0,
                  updated_fail: true,
                })
                .then((result) => {
                  that.uploading = false;
                });
              reject(err);
            },
            blockSize: file.size,
          },
          axios.create()
        );
      });
    },
    async callBackUpload(result, uuid, curId) {
      const that = this;
      that.setFileArgs(curId, { uploading: true, progress: 52 });
      return new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_attachments",
            url: "/fileManager/add-file-callback/",
            data: {
              result: result,
              uuid: uuid,
            },
            type: "upload",
            global: false,
          })
          .then((res) => {
            that.setFileArgs(curId, { uploading: false, progress: 78 });
            reslove(res);
          })
          .catch((err) => {
            that
              .setFileArgs(curId, {
                uploading: false,
                progress: 0,
                updated_fail: true,
              })
              .then((result) => {
                that.uploading = false;
              });
            reject(err);
          });
      });
    },
    async toUpdate(file, id) {
      const that = this;
      await that
        .getUploadInfo(file.name, file.size, id)
        .then((res) => {
          that
            .UploadAvatar(file, res.data, id)
            .then((result) => {
              if (result === true) {
                that
                  .callBackUpload(1, res.data.uuid, id)
                  .then((resu) => {
                    if (resu.data.type == "update") {
                      that
                        .onUploadAvatar(res.data.uuid, id)
                        .then((resul) => {
                          // 上传成功
                          that
                            .setFileArgs(id, {
                              updated: true,
                              uuid: resul.data["files"][0].uuid,
                              online_file: resul.data["files"][0],
                              Url: resul.data["files"][0].path,
                            })
                            .then((result) => {
                              that.uploading = false;
                            });
                        })
                        .catch((err) => {
                          that.uploading = false;
                        });
                    } else {
                      //上报失败
                    }
                  })
                  .catch((err) => {
                    console.log(err); //上报失败
                  });
              }
            })
            .catch((err) => {
              // 上传失败
              console.log(err);
              that.callBackUpload(0, res.data.uuid, id);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>